import { createAsyncThunk } from '@reduxjs/toolkit';

import getUserByToken from 'services/users/getUserByToken';

export const getUserByTokenAction = createAsyncThunk('users/getUserByToken', async (token) => {
  const userData = await getUserByToken(token);

  return { userData };
});
